import { ballArr, count, singleDouble, singleDoubleCnname, smallBig, smallBigCnname, dragonTiger, fishCnname } from '../../../../helpers/resPatterns';
import dayjs from 'dayjs';

const xyrb = () => {
  const list = Vue => {
    return [
      {
        title: '时间',
        align: 'center',
        render: (h, { row }) => {
          return <span>{dayjs(row.resultDate).format('YYYY-MM-DD HH:mm:ss')}</span>;
        }
      },
      {
        title: '期数',
        align: 'center',
        key: 'issueId'
      },
      {
        title: '开奖号码',
        align: 'center',
        render: (h, { row }) => {
          return (
            <div class="ball num">
              {ballArr(row.resultStr).map((x, i) => {
                return <span>{x}</span>;
              })}
            </div>
          );
        }
      },
      {
        title: '总和',
        align: 'center',
        render: (h, { row }) => {
          let arr = ballArr(row.resultStr);
          return (
            <div class="insideTableTd">
              <p class="count brr">{count(arr)}</p>
              <p class="singleDouble brr">{singleDouble(count(arr)) == 0 ? <span class="blue">单</span> : <span class="red">双</span>}</p>
              <p class="smallBig">{smallBig(count(arr), 27) == 0 ? <span class="blue">小</span> : <span class="red">大</span>}</p>
            </div>
          );
        }
      }
    ];
  };
  return { list };
};

export default xyrb;



// WEBPACK FOOTER //
// ./src/pages/Trend/Jibenzoushi/columns/xyrb.js